import { useEffect, useState } from "react";
import {  IPaginationV2 } from "../../Interfaces/base/ITable";
import { CommandBar, ICommandBarItemProps } from "@fluentui/react";
import Pagination from "../Pagination/pagination";

export const PaginationFooterComponent=(props:IPaginationV2)=>{
    const [itemByPage, setItemByPage] = useState(props.take);
    useEffect(() => {
        if(typeof props.onSizeChange === 'function'){
           props.onSizeChange(itemByPage)
        }
      }, [itemByPage]);

      useEffect(() => {
        setItemByPage(props.take)
      }, [props.take])
      
      const onNext = () => {
        props.onPageChange(props.currentPage + 1);
      };
    
      const onPrevious = () => {
        props.onPageChange(props.currentPage - 1);
      };
      const footerLeft = () => {
        let start= props.skip+1
        start = start>props.total?props.total:start
        let end = props.skip+props.take
        end = end>props.total?props.total:end

        const _items: ICommandBarItemProps[] = [
          {
            key: "ItemsByPage",
            text: `Items por pagina ${itemByPage}`,
            split: true,
            disabled: false,
            subMenuProps: {
              items: [
                {
                  key: "five",
                  text: "5",
                  iconProps: { iconName: "WorkItemBarSolid" },
                  onClick: () => setItemByPage(5),
                },
                {
                  key: "ten",
                  text: "10",
                  iconProps: { iconName: "WorkItemBarSolid" },
                  onClick: () => setItemByPage(10),
                },
                {
                  key: "twentyFive",
                  text: "25",
                  iconProps: { iconName: "WorkItemBarSolid" },
                  onClick: () => setItemByPage(25),
                },
                {
                  key: "hundred",
                  text: "100",
                  iconProps: { iconName: "WorkItemBarSolid" },
                  onClick: () => setItemByPage(100),
                },
              ],
            },
            className: "ms-fontSize-12",
          },
          {
            key: "Info",
            text: `${start} - ${end} de ${props.total}`,
            className: "ms-fontSize-12",
          },

        ]
        return _items; 
      }
      const footerRigth = () => {
        const _items: ICommandBarItemProps[] = [
          {
            key: "Pagination",
            onRender: () => (
            <ul style={{ marginTop: '7px' }}className={'pagination-container'}>
            <li className={`pagination-item ${props.currentPage === 1 || props.currentPage===0 ? 'disabled' : ''}`}
             onClick={onPrevious}>
            <div className="arrow left" />
            </li>
            <li className={`pagination-item ${props.currentPage === props.pageSize ? 'disabled' : ''}`}
           onClick={onNext}>
            <div className="arrow right" />
            </li>
            </ul>
            ),
          },
        ];
        return _items;
      };
      return (
        <>
          <CommandBar
            className="ms-fontSize-10"
            items={footerLeft()}
            farItems={footerRigth()}
            styles={{ root: { padding: 0} }}
            style={{ width: props.tableSize ? "80%" : "unset" }}
            />
        </>
      );
}